import { Box, Flex, VStack, Text, HStack } from "@chakra-ui/react";
import { Archive, Skull, TriangleAlert } from "lucide-react";

interface PharmacyStatsCardProps {
  stats: {
    total_products: number;
    expired_products: number;
    low_stock_products: number;
  };
}

export function PharmacyStatsCard({ stats }: PharmacyStatsCardProps) {
  return (
    <Box mb={4}>
      <Flex
        gap="24px"
        mb={4}
        flexWrap={{ base: "wrap", md: "nowrap" }}
        align="stretch"
      >
        {/* Total Products Card */}
        <Box
          w={{ base: "100%", md: "261px" }}
          h="146px"
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          bgImage="/assets/img/totalproducts.png"
          bgPosition="-2px center"
          bgSize="cover"
          bgRepeat="no-repeat"
          p="20px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          shadow="sm"
        >
          <HStack justify="space-between" width="100%">
            <Box
              w="40px"
              h="40px"
              bg="#11DCB0"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              <Archive size={20} color="white" />
            </Box>
            <Text fontSize="xs" color="gray.400">
              Now
            </Text>
          </HStack>
          <VStack align="flex-start" spacing={0} mt="auto">
            <Text fontSize="xs" color="gray.600" fontWeight="500">
              Total Products
            </Text>
            <Text
              fontSize="3xl"
              fontWeight="700"
              color="#0A1B39"
              lineHeight="1"
            >
              {stats.total_products}
            </Text>
          </VStack>
        </Box>

        {/* Expired Products Card */}
        <Box
          w={{ base: "100%", md: "261px" }}
          h="146px"
          bg="white"
          border="1px solid"
          borderColor="#D40606"
          borderRadius="md"
          bgImage="/assets/img/expired.png"
          bgSize="cover"
          bgRepeat="no-repeat"
          p="20px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          shadow="sm"
        >
          <HStack justify="space-between" width="100%">
            <Box
              w="40px"
              h="40px"
              bg="#D40606"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              <Skull size={20} color="white" />
            </Box>
            <Text fontSize="xs" color="gray.400">
              Now
            </Text>
          </HStack>
          <VStack align="flex-start" spacing={0} mt="auto">
            <Text fontSize="xs" color="gray.600" fontWeight="500">
              Expired Products
            </Text>
            <Text
              fontSize="3xl"
              fontWeight="700"
              color="#0A1B39"
              lineHeight="1"
            >
              {stats.expired_products}
            </Text>
          </VStack>
        </Box>

        {/* Low Stocks Card */}
        <Box
          w={{ base: "100%", md: "261px" }}
          h="146px"
          bg="white"
          border="1px solid"
          borderColor="#EF981E"
          borderRadius="md"
          bgImage="/assets/img/lowstocks.png"
          bgSize="cover"
          bgRepeat="no-repeat"
          p="20px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          shadow="sm"
        >
          <HStack justify="space-between" width="100%">
            <Box
              w="40px"
              h="40px"
              bg="#EF981E"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              <TriangleAlert size={20} color="white" />
            </Box>
            <Text fontSize="xs" color="gray.400">
              Now
            </Text>
          </HStack>
          <VStack align="flex-start" spacing={0} mt="auto">
            <Text fontSize="xs" color="gray.600" fontWeight="500">
              Low Stocks
            </Text>
            <Text
              fontSize="3xl"
              fontWeight="700"
              color="#0A1B39"
              lineHeight="1"
            >
              {stats.low_stock_products}
            </Text>
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
}

export default PharmacyStatsCard;
